import React, { useState } from "react";
import { api } from "./api";

/**
 * 메모 탭 — 언제든 편집·저장 가능한 자유 메모.
 * path: 저장 대상 엔티티 경로 (예: /companies/3), field: 저장할 필드명 (예: "note"), value: 초기값
 */
export default function MemoTab({ path, field, value, onSaved, placeholder }) {
  const [text, setText] = useState(value || "");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [msg, setMsg] = useState("");

  async function save() {
    if (busy) return;
    setBusy(true); setError(""); setMsg("");
    try {
      await api.post(path, { [field]: text });
      setMsg("저장되었습니다.");
      if (onSaved) onSaved();
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="sstoa-section">
      <div className="sstoa-section__head">
        <h2>메모</h2>
        <button type="button" className="sstoa-btn sstoa-btn--primary sstoa-btn--sm" onClick={save} disabled={busy}>
          {busy ? "저장 중…" : "저장"}
        </button>
      </div>
      {error && <div className="sstoa-error" style={{ marginBottom: 10 }}>{error}</div>}
      {msg && <div className="sstoa-error" style={{ marginBottom: 10, background: "#e7f6ec", borderColor: "#b6e0c4", color: "#1f7a3d" }}>{msg}</div>}
      <div className="sstoa-panel sstoa-panel--pad">
        <textarea
          className="sstoa-textarea"
          style={{ minHeight: 300 }}
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder={placeholder || "메모를 자유롭게 입력하세요."}
          disabled={busy}
        />
      </div>
    </div>
  );
}
